"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = login;

var _clientAuth = require("@devsta/client-auth");

var _login2 = _interopRequireDefault(require("../queries/login"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function login(_x, _x2, _x3) {
  return _login.apply(this, arguments);
}

function _login() {
  _login = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(variables, apolloClient, onLogin) {
    var result, auth;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return apolloClient.query({
              query: _login2.default,
              variables: variables,
              context: {
                module: 'users'
              }
            });

          case 3:
            result = _context.sent;

            if (!result.errors) {
              _context.next = 6;
              break;
            }

            throw new Error(result.errors[0].message);

          case 6:
            auth = result.data.login.auth;

            if (auth) {
              _context.next = 9;
              break;
            }

            throw new Error('Login failed plase try again');

          case 9:
            _clientAuth.authLocalStore.save(result);

            if (onLogin) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("return");

          case 12:
            onLogin(result);
            _context.next = 18;
            break;

          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](0);
            throw _context.t0;

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 15]]);
  }));
  return _login.apply(this, arguments);
}